import ImageIcon from '@/icons/menu/ImageIcon';
import type { MenuSection } from '../types';

export const companyMenu = () =>
  ({
    type: 'section',
    id: 'company',
    label: 'My Company',
    children: [
      {
        type: 'link',
        id: 'company-profile',
        label: 'Company Profile',
        icon: ({ isActive }) =>
          isActive ? (
            <ImageIcon.Primary className="shrink-0 text-xs text-violet-500 !size-3" />
          ) : (
            <ImageIcon className="shrink-0 text-xs text-neutral-500 !size-3" />
          ),
        href: '/company/profile',
      },
    ],
  }) as const satisfies MenuSection;
